import { allPhotos } from "./allPhotos";

export const essayPhotos = allPhotos.filter(function(obj) { return obj.type === 'Ensaio'; });